import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import Actualites from './components/Pages/Actualites/Actualites';
import AppelsDeFonds from './components/Pages/AppelsDeFonds/AppelsDeFonds';
import AvantagesEtServices from './components/Pages/AvantagesEtServices/AvantagesEtServices';
import Documents from './components/Pages/Documents/Documents';
import Home from './components/Pages/Home/Home';
import Messages from './components/Pages/Messages/Messages';
import MonLogement from './components/Pages/MonLogement/MonLogement';
import MonProfil from './components/Pages/MonProfil/MonProfil';
import { AccessType, useAuth } from './contexts/authContext';

const Router = () => {

    const { accessType } = useAuth();

    const ProtectedRoute = (props) => {
        const { children } = props;
        if (accessType === AccessType.prospect) return <Navigate to="/monprofil" replace />;
        else return children ? children : <Outlet />;
    };

    return <Routes>
        <Route element={<ProtectedRoute />}>
            <Route index element={<Home />} />
            <Route path="/actualites/*" element={<Actualites />} />
            <Route path="/appelsdefonds/*" element={<AppelsDeFonds />} />
            <Route path="/avantagesetservices/*" element={<AvantagesEtServices />} />
            <Route path="/documents/*" element={<Documents />} />
            <Route path="/messages/*" element={<Messages />} />
            <Route path="/monlogement/*" element={<MonLogement />} />
        </Route>
        <Route path="/monprofil/*" element={<MonProfil />} />
    </Routes>;

};

export default Router;